import { useState } from "react";

import { cn } from "@/lib/utils";

type InputProps = React.ComponentProps<"input"> & {
  // returns an error message if the input's value checks out as invalid
  // empty string means there it is valid
  validator?: (value: string) => string;
};

function Input({ type, onChange, className, validator, ...props }: InputProps) {
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | undefined>();

  return (
    <span className="flex flex-col gap-1 w-full">
      <input
        type={type}
        data-slot="input"
        value={value}
        onChange={(e) => {
          onChange?.(e);
          const newValue = e.target.value;
          setValue(newValue);
          setError(validator?.(newValue));
        }}
        aria-invalid={error ? "true" : "false"}
        aria-describedby={error ? "input-error" : undefined}
        className={cn(
          "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className,
        )}
        {...props}
      />
      {error && (
        <p role="alert" className="text-xs text-destructive">
          {error}
        </p>
      )}
    </span>
  );
}

export { Input };
